<template>
  <ul class="notification-list">
    <li v-if="!loaded">{{ $t("message.loading") }}</li>
    <notification-item
      v-for="notification in notifications"
      :notification="notification"
    ></notification-item>
    <li v-if="loaded && !notifications.length" class="no-notifications">
      {{ $t("message.no-notifications") }}
    </li>
  </ul>
</template>

<style lang="less" scoped>
.no-notifications {
  margin: 40px 0 0 0;
}
</style>

<script>
import axios from "axios";
import NotificationItem from "./NotificationItem.vue";

export default {
  data: function() {
    return {
      loading: false,
      loaded: false,
      notifications: []
    };
  },
  mounted: function() {
    if (!this.loading && !this.loaded) {
      this.loading = true;
      axios.get("/programs/api/activity").then(response => {
        this.notifications = response.data;
        this.loading = false;
        this.loaded = true;
        this.$store.commit("clearNotificationCount");
      });
    }
  },
  props: ["notification"],
  components: { NotificationItem }
};
</script>
